export default __webpack_public_path__ + "static/media/navi.fa5f7dd8.gif";